import { buildEditarAutomacaoFormSteps } from './automacaoTourSteps'

const buildEditarAutomacaoTourSteps = (tourManager) => [
    {
        popover: {
            title: 'Automações',
            description: 'Uma automação faz a plataforma executar uma ação automaticamente quando algo acontece. Por exemplo, ela pode ligar ou desligar um equipamento, enviar um comando ou gerar um alerta.<br><br>Neste guia, você verá como funciona cada etapa desta automação já cadastrada e o que pode ser alterado.',
            side: 'over',
            align: 'center',
        },
    },
    ...buildEditarAutomacaoFormSteps(tourManager),
]

export default buildEditarAutomacaoTourSteps
